import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { createAppKit } from "@reown/appkit/react";
import { hoodi, polygonAmoy, mainnet } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { WagmiProvider } from "wagmi";
import ConnectionStatus from "./ConnectionStatus";
import { Suspense } from "react";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
  queryCache: new QueryCache({
    onError: (error) => {
      console.log(error);
      // notify('error', 'Something went wrong!');
    },
  }),
});

const wagmiAdapter = new WagmiAdapter({
  networks: [hoodi, polygonAmoy],
  projectId: import.meta.env.VITE_PROJECT_ID,
  ssr: true,
});

const metadata = {
  //optional
  name: "AppKit",
  description: "AppKit Example",
  url: "https://example.com",
  icons: ["https://avatars.githubusercontent.com/u/179229932"],
};

createAppKit({
  adapters: [wagmiAdapter],
  defaultNetwork: hoodi,
  networks: [hoodi, polygonAmoy],
  metadata: metadata,
  projectId: import.meta.env.VITE_PROJECT_ID,
  features: {
    analytics: true,
    socials: false,
    onramp: false,
    swaps: false,
    receive: false,
    send: false,
    history: true,
    email: false,

    // walletFeaturesOrder: ['receive', 'send', 'onramp', 'swaps'],
  },
  enableReconnect:true,
  enableWallets: true,
  enableWalletConnect: true, // Optional - true by default
  enableInjected: true, // Optional - true by default
  enableEIP6963: true,
  // debug:true,
  themeMode: "light",
});

export default function ConnectWalletProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={wagmiAdapter.wagmiConfig}>
         <Suspense fallback={<div>Loading...</div>}> 
          <ConnectionStatus>{children}</ConnectionStatus>
         </Suspense> 
      </WagmiProvider>  
    </QueryClientProvider>
  );
}
